import React, {
  FC, useEffect,
} from 'react';
import { v4 as uuid } from 'uuid';
import {
  RowLeft,
} from '../Styles';
import UserReply from '../components/Reply/UserReply';
import OptionButton from '../components/Button/OptionButton';
import RobotReply from '../components/Reply/RobotReply';
import { getWindowWidth, lang } from '../../../../../lib/utils/utils';
import LeftToRight from '../components/Animation/LeftToRight';
import { addSystemLog } from '../../../../../lib/SystemLogUtils';

/**
 * 需要登录进入Q2_1
 */
const Q2_1: FC<Props> = ({
  addElement,
  cabId,
  h5Platform,
  setTargetPage,
  setIsToSelectLockerPage,
  deviceCode,
  sessionId,
}) => {
  // 选项
  const options: {zhValue: string; enValue: string}[] = [
    { zhValue: '立即注册', enValue: 'Sign up now' },
  ];

  const send = () => {
    if (setIsToSelectLockerPage) {
      setIsToSelectLockerPage(true);
    }
    // 进入注册用户页面
    setTargetPage('register-parcel-user');
  };

  useEffect(() => {
    // 流程ID，同一个流程下的按钮，只要点击了一次就加入到流程ID中，避免重复点击
    const flowId = uuid();
    const langZh = '要从我们的智能柜领取物品，您需要先注册。';
    const langEn = 'To pick-up from our lockers you need to sign up.';
    addElement(
      <LeftToRight flowId={flowId}>
        <RowLeft style={{ marginTop: 25 }}>
          <RobotReply
            style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.57, getWindowWidth() * 0.58) }}
            langZh={langZh}
            langEn={langEn}
          />
        </RowLeft>
      </LeftToRight>
    );

    // 机器人回复日志
    addSystemLog(cabId, deviceCode, h5Platform + '', 'Q2-1 - bot: ' + langEn, sessionId);

    setTimeout(() => {
      addElement(
        <LeftToRight flowId={flowId}>
          {
            options.map(({ zhValue, enValue }, index) => {
              return (
                <RowLeft>
                  <OptionButton
                    langZh={(
                      (
                        <div style={{ width: 229, textAlign: 'center' }}>
                          { zhValue }
                        </div>
                      )
                    )}
                    langEn={(
                      <div style={{ width: 219, textAlign: 'center' }}>
                        { enValue }
                      </div>
                    )}
                    flowId={flowId}
                    callback={() => {
                      // 用户回复日志
                      addSystemLog(cabId, deviceCode, h5Platform + '', 'Q2-1 - user: ' + enValue, sessionId);
                      addElement(
                        <UserReply
                          langZh={zhValue}
                          langEn={enValue}
                        />
                      );
                      send();
                    }}
                  />
                </RowLeft>
              );
            })
          }
        </LeftToRight>
      );
    }, 200);
  }, []);

  return (
    <></>
  );
};

export interface Props {
  cabId: number;
  h5Platform: number;
  addElement: (elements: any) => void;
  setTargetPage: (targetPage: string) => void;
  setIsToSelectLockerPage?: (isToLockerPage: boolean) => void;
  deviceCode: string;
  sessionId: string;
}

export default Q2_1;
